import * as HSC from './hsc.constants';
import { HistorianStorageConfiguration } from '../../models/entities/HistorianStorageConfiguration';

/** LOAD */
export function loadHistorianStorageConfigurations() {
    return { type: HSC.HSCS_LOAD };
}

export function loadHistorianStorageConfigurationsSuccess(data: HistorianStorageConfiguration[]) {
    return { type: HSC.HSCS_LOAD_SUCCESS, payload: data };
}

export function loadHistorianStorageConfigurationsError(error: any) {
    return { type: HSC.HSCS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addHistorianStorageConfigurations(targetConfigurations: HistorianStorageConfiguration[]) {
    return { type: HSC.HSCS_ADD, payload: targetConfigurations };
}

export function addHistorianStorageConfigurationsSuccess(targetConfigurations: HistorianStorageConfiguration[]) {
    return { type: HSC.HSCS_ADD_SUCCESS, payload: targetConfigurations };
}

export function addHistorianStorageConfigurationsError(error: any) {
    return { type: HSC.HSCS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateHistorianStorageConfiguration(targetConfiguration: HistorianStorageConfiguration) {
    return { type: HSC.HSC_UPDATE, payload: targetConfiguration };
}

export function updateHistorianStorageConfigurationSuccess(targetConfiguration: HistorianStorageConfiguration) {
    return { type: HSC.HSC_UPDATE_SUCCESS, payload: targetConfiguration };
}

export function updateHistorianStorageConfigurations(targetConfigurations: HistorianStorageConfiguration[]) {
    return { type: HSC.HSCS_UPDATE, payload: targetConfigurations };
}

export function updateHistorianStorageConfigurationsSuccess(targetConfigurations: HistorianStorageConfiguration[]) {
    return { type: HSC.HSCS_UPDATE_SUCCESS, payload: targetConfigurations };
}

export function updateHistorianStorageConfigurationsError(error: any) {
    return { type: HSC.HSCS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteHistorianStorageConfiguration(guid: string) {
    return { type: HSC.HSC_DELETE, payload: guid };
}
export function deleteHistorianStorageConfigurationSuccess(guid: string) {
    return { type: HSC.HSC_DELETE_SUCCESS, payload: guid };
}

export function deleteHistorianStorageConfigurations(guids: string[]) {
    return { type: HSC.HSCS_DELETE, payload: guids };
}

export function deleteHistorianStorageConfigurationsSuccess(configurations: HistorianStorageConfiguration[]) {
    return { type: HSC.HSCS_DELETE_SUCCESS, payload: configurations };
}

export function deleteHistorianStorageConfigurationsError(error: any) {
    return { type: HSC.HSCS_DELETE_ERROR, payload: error };
}